import { BoxTitles } from "@boxes/BoxTitles";
import { memo } from "react";
import { ReportFooter } from "../layout/ReportFooter";
import SourceBaseBox from "../layout/SourceBaseBox";

export default memo(({ id, selected, isConnectable }) => {
  return (
    <SourceBaseBox
      title={BoxTitles.FullAudience}
      selected={selected}
      isConnectable={isConnectable}
      footer={<ReportFooter id={id} />}
    />
  );
});
